import { http, HttpResponse } from 'msw'

interface MockDeactivateCardPathParams {
  alphaId: string
  cardId: string
}

export const mockDeactivateCard = http.put<MockDeactivateCardPathParams>(
  '/my-business/api/agency/v1/*/:alphaId/cards/:cardId/deactivate',
  () => {
    return HttpResponse.json(null, { status: 200 })
  },
)
